const errTxt = (message?: string | Error, postion?: string): string => {
  if (message === undefined) {
    return postion ? `[SF Error] @ ${postion}` : '[SF Error]';
  }
  if (typeof message === 'string') {
    const m = `${message ? message : ''}${postion ? ` @ ${postion}` : ''}`;
    return m.startsWith('[SF Error]') ? m : `[SF Error] ${m}`;
  }
  return errTxt(message.message, postion);
};

export class SlugError extends Error {
  public constructor(message?: string | Error, postion?: string) {
    super(errTxt(message, postion));
  }
}

interface ISlugConsole {
  debug(msg: string): string;
  log(msg: string): string;
  succ(msg: string): string;
  warn(msg: string): string;
  error(msg: string): SlugError;
}

const enum Color {
  Grey = '#aaa',
  Blue = '#2d8cf0',
  Green = '#19be6b',
  Orange = 'orange',
  // Red = 'red',
}

export class SlugConsole implements ISlugConsole {
  private ns: string;
  public constructor(ns = 'SF') {
    this.ns = ns;
  }

  // TODO:
  public debug(msg: string) {
    const m = this.txt(msg);
    console.debug(`%c ${m}`, `color: ${Color.Grey};`);
    return m;
  }
  public log(msg: string) {
    const m = this.txt(msg);
    console.log(`%c ${m}`, `color: ${Color.Blue};`);
    return m;
  }
  public succ(msg: string) {
    const m = this.txt(msg);
    console.log(`%c ${m}`, `color: ${Color.Green};`);
    return m;
  }
  public warn(msg: string) {
    const m = `[${this.ns}] ${msg}`;
    console.warn(`%c ${m}`, `color: ${Color.Orange};`);
    return m;
  }
  public error(msg: string | SlugError | Error) {
    if (typeof msg === 'string') {
      const e = new SlugError(msg, this.ns);
      console.error(e);
      return e;
    }
    console.error(msg);
    return msg;
  }

  private txt(msg: string) {
    return `[${this.ns}] ${msg}`;
  }
}

// TODO: 文档注明
// export const slugConsole = new SlugConsole('SF');
